import project1 from "../assets/project1.png";
import project2 from "../assets/project2.png";
import project3 from "../assets/project3.png";


const PROJECTS = [
  {
    id: 1,
    title: "project1",
    description:
      "My gallery",
    link: "http://ishealdream.com/",
    image: project1
  },
  {
    id: 2,
    title: "project2",
    description:
      "Lalala~",
    image: project2
  },
  {
    id: 3,
    title: "project3",
    description:
      "Meow~",
    link: "https://github.com/babymimo/",
    image: project3
  }
];

export default PROJECTS;
